/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/FileDownloadDone';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const FileDownloadDoneIcon = withMuiAdapter(Base, 'FileDownloadDone');
